(function () {
  'use strict';

  angular.module('ringbaPortal').component('ivrRouteFilter', {
    bindings: {
      hideFilterPopover: '&',
      link: '<',
      linkIndex: '<',
      ivrTree: '<',
      parentNodeId: '<',
      setCriteria: '<'
    },
    controller: IvrRouteFilterController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/ivr-route-filter/ivr-route-filter.view.html'
  });

  function IvrRouteFilterController(
    accountsService,
    ivrService
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.submitCriteria = submitCriteria;

    function onInit() {
      _getTags();
      vm.filterContainerObj = {
        criteria: vm.link.criteria && vm.link.criteria.length ? angular.copy(vm.link.criteria) : undefined
      };
    }

    function submitCriteria() {
      return vm.setCriteria(vm.link.childNodeId, vm.parentNodeId, vm.filterContainerObj.criteria, vm.linkIndex).then(function () {
        vm.hideFilterPopover({
          linkId: vm.link.childNodeId
        });
      });
    }
    function _getTags() {
      ivrService.getAvailableTags(accountsService.currentAccountId, vm.ivrTree, vm.parentNodeId).then(function (tags) {
        vm.availableTags = tags;
      });
    }
  }
})();
